
import React from 'react';
import './AlertInbox.scss';

export default () => (
    <iframe src="/HtmlClient/AlertInbox.html" style={{ width: '100%', height: '100%' }}></iframe>
);